import { useIntl } from 'react-intl';

import { Chip } from '@ocx/ui';
import { TimerIcon } from '@ocx/ui-icons';

import { messages } from './offer-label.messages';

export interface OfferExpirationChipProps {
  time: string;
}

export const OfferExpirationChip = ({ time }: OfferExpirationChipProps) => {
  const intl = useIntl();

  return (
    <Chip
      variant="body2"
      elevated
      color="offerLabel.Expires.color"
      bgcolor="offerLabel.Expires.backgroundColor"
      startIcon={<TimerIcon sx={{ width: 14, height: 14 }} />}>
      {intl.formatMessage(messages.Expires, {
        time,
      })}
    </Chip>
  );
};
